import React, { useEffect } from 'react';

const AdSense = () => {
    useEffect(() => {
      const script = document.createElement('script');
      script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-4565925289497624";
      script.async = true;
      document.head.appendChild(script);
  
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }, []);
  
    return (
      <ins className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-4565925289497624"
        data-ad-slot="4561273879"
        data-ad-format="auto"
        data-full-width-responsive="true" />
    );
  }
  export default AdSense;